import React, { useEffect, useRef, useState } from "react";
import { fabric } from "fabric";
import styles from "./BrandAsset.module.scss";
import { FaPlus } from "../ImageUpload/icons/uploadIcons";
import imgNotFound from "../../assets/images/single-image.png";
import SingleActivity from "../NewComponents/NewUiActivities/SingleActivity/SingleActivity";
import Loader from "../Loader/Loader";
import CustomPagination from "../CustomPagination/CustomPagination";
import { getDecryptedData } from "../../utils/crypto";
import WebFont from "webfontloader";
import topLogoRightImage from '../../assets/images/templates/top-logo-right-text.png';
import topLogoCenterImage from '../../assets/images/templates/top-logo-center-text.png';
import topLogoLeftImage from '../../assets/images/templates/top-logo-left-text.png';
import bottomLogoRightImage from '../../assets/images/templates/bottom-logo-right-text.png';
import bottomLogoCenterImage from '../../assets/images/templates/bottom-logo-center-text.png';
import bottomLogoLeftImage from '../../assets/images/templates/bottom-logo-left-text.png';

const ImageEditor = () => {
  const userType = localStorage.getItem("userType");
  const token = getDecryptedData("userToken");
  const agent_selected_id = JSON.parse(localStorage.getItem("userDetails"));
  const [agentData, setAgentData] = useState(null);
  const [agentLogo, setAgentLogo] = useState(null);
  const [showDownloadButton, setShowDownloadButton] = useState(false);

  const [loader, setLoader] = useState(false);
  const canvasRef = useRef(null);
  const [canvas, setCanvas] = useState(null);
  const [canvasSize, setCanvasSize] = useState({ width: 500, height: 500 });
  const [backgroundUrl, setBackgroundUrl] = useState("");
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [selectedText, setSelectedText] = useState(null);
  const [textSize, setTextSize] = useState(24);
  const [textColor, setTextColor] = useState("#000000");
  const [textWeight, setTextWeight] = useState(500);
  const [googleFonts, setGoogleFonts] = useState([]);
  const [selectedFont, setSelectedFont] = useState("Arial");

  const [selectedImage, setSelectedImage] = useState(null);
  const [history, setHistory] = useState([]);
  const [elements, setElements] = useState([]);
  const [redoStack, setRedoStack] = useState([]);
  const [textInput, setTextInput] = useState("");
  const [color, setColor] = useState("#000000");

  const [openPopupSection, setOpenPopupSection] = useState(false);
  const [openPopupSectionActivity, setOpenPopupSectionActivity] = useState(false);
  const [openPopupSectionPackage, setOpenPopupSectionPackage] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const fetchAgentDetails = (token) => {
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/user-profile`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setAgentData(data.data);
        localStorage.setItem(
          "AccountStatus",
          JSON.stringify(data.data.accountStatus)
        );
        // if (data.success) {
        //   if (!data?.data?.name || !data?.data?.email || !data?.data?.phone) {
        //     return Navigate("/agent-account");
        //   }
        //   Navigate("/agent-dashboard");
        // }
        localStorage.setItem("userDetails", JSON.stringify(data.data));
      })
      .catch((error) => {
        console.error("Error fetching agent details:", error);
      });
  };

  useEffect(() => {
    if (token && userType === "agent") {
      fetchAgentDetails(token);
    }
  }, [token]);

  const popularFonts = [
    "Inter", "Poppins", "Roboto", "Montserrat", "Lato", "Open Sans",
    "Raleway", "Nunito", "Playfair Display", "Merriweather", "Oswald"
  ];

  useEffect(() => {
    const fetchGoogleFonts = async () => {
      try {
        const response = await fetch(
          "https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyD_J5gvhd8Qm6JNSt8OrQ7bCz3Cze0Vr_A"
        );
        const data = await response.json();

        // Filter fonts based on the popularFonts list
        const filteredFonts = data.items
          .map(font => font.family)
          .filter(font => popularFonts.includes(font));

        setGoogleFonts(filteredFonts);
      } catch (error) {
        console.error("Failed to fetch Google Fonts:", error);
      }
    };

    fetchGoogleFonts();
  }, []);

  useEffect(() => {
    if (!canvasRef.current) return;

    const fabricCanvas = new fabric.Canvas(canvasRef.current, {
      width: canvasSize.width,
      height: canvasSize.height,
    });

    const updateSelection = (event) => {
      const selectedObj = event.selected?.[0];

      if (selectedObj?.type === "textbox") {
        setSelectedText(selectedObj);
        setTextSize(selectedObj.fontSize || 24);
        setTextColor(selectedObj.fill || "#000000");
        setTextWeight(selectedObj.fontWeight || "normal");
      } else {
        setSelectedText(null);
      }

      if (selectedObj?.type === "image") {
        setSelectedImage(selectedObj);
      } else {
        setSelectedImage(null);
      }
    };

    fabricCanvas.on("selection:created", updateSelection);
    fabricCanvas.on("selection:updated", updateSelection);
    fabricCanvas.on("selection:cleared", () => {
      setSelectedText(null);
      setSelectedImage(null);
    });

    setCanvas(fabricCanvas);
    return () => fabricCanvas.dispose();
  }, [canvasSize]);

  const updateFontFamily = (font) => {
    setSelectedFont(font);

    WebFont.load({
      google: {
        families: [font],
      },
      active: () => {
        if (selectedText) {
          selectedText.set("fontFamily", font);
          canvas.renderAll();
        }
      },
    });
  };

  // const updateBackgroundImage = (imageUrl) => {
  //   if (!canvas) return;
  //   fabric.Image.fromURL(imageUrl, (img) => {
  //     img.set({
  //       left: 0,
  //       top: 0,
  //       scaleX: canvas.width / img.width,
  //       scaleY: canvas.height / img.height,
  //     });

  //     canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
  //     setBackgroundImage(img);
  //   });
  // };

  // const updateBackgroundImage = (imageUrl, defaultText = "Edit Me") => {
  //   if (!canvas) return;

  //   const objectsToRemove = canvas.getObjects().filter(obj => obj.type === "textbox");
  //   objectsToRemove.forEach(obj => canvas.remove(obj));

  //   fabric.Image.fromURL(imageUrl, (img) => {
  //     img.set({
  //       left: 0,
  //       top: 0,
  //       scaleX: canvas.width / img.width,
  //       scaleY: canvas.height / img.height,
  //     });

  //     canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
  //     setBackgroundImage(img);

  //     const text = new fabric.Textbox(defaultText, {
  //       left: 0,
  //       top: canvas.height - 40, // Position at bottom
  //       width: canvas.width, // Full width
  //       fontSize: 24,
  //       fill: "#ffffff", // White text color
  //       fontWeight: "bold",
  //       textAlign: "center",
  //       backgroundColor: "rgba(0,0,0,0.7)", // Semi-transparent black background
  //       selectable: true, // Allow user to edit
  //     });

  //     canvas.add(text);
  //     canvas.renderAll();
  //   });

  // };

  const handleBackgroundUrlChange = (e) => {
    const url = e.target.value;
    setBackgroundUrl(url);
    updateBackgroundImage(url);
  };

  const handleBackgroundUpload = (e) => {
    if (!canvas) return;
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      setBackgroundUrl("");
      updateBackgroundImage(event.target.result);
    };
    reader.readAsDataURL(file);
  };

  const removeBackgroundImage = () => {
    if (!canvas) return;
    canvas.setBackgroundImage(null, canvas.renderAll.bind(canvas));
    setBackgroundUrl("");
    setBackgroundImage(null);

    // Find and remove any text elements from the canvas
    const objectsToRemove = canvas.getObjects().filter(obj => obj.type === "textbox");
    objectsToRemove.forEach(obj => canvas.remove(obj));
    canvas.renderAll();
  };

  const handleImageUpload = (e) => {
    if (!canvas) return;
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      fabric.Image.fromURL(event.target.result, (img) => {
        img.set({
          left: 50,
          top: 50,
          scaleX: 0.5,
          scaleY: 0.5,
          selectable: true,
        });

        canvas.add(img);
        canvas.renderAll();
      });
    };
    reader.readAsDataURL(file);
  };

  const deleteSelectedImage = () => {
    if (!canvas || !selectedImage) return;
    canvas.remove(selectedImage);
    setSelectedImage(null);
    canvas.renderAll();
  };

  const addText = () => {
    if (!canvas) return;

    const text = new fabric.Textbox("Edit Me", {
      left: 100,
      top: 100,
      fontSize: textSize,
      fill: textColor,
      selectable: true,
      fontWeight: textWeight,
    });
    const newElement = {
      id: Date.now(),
      type: "text",
      text: textInput,
      color,
      x: 50,
      y: 50,
    };
    saveToHistory();
    setElements([...elements, newElement]);
    canvas.add(text);
    canvas.renderAll();
  };

  const updateTextSize = (size) => {
    if (!selectedText || !canvas) return;
    selectedText.set({ fontSize: parseInt(size, 10) });
    canvas.renderAll();
  };

  const updateTextWeight = (weight) => {
    if (!selectedText || !canvas) return;
    selectedText.set({ fontWeight: weight });
    canvas.renderAll();
  };

  const updateTextColor = (color) => {
    if (!selectedText || !canvas) return;
    selectedText.set({ fill: color });
    canvas.renderAll();
  };

  // const downloadImage = () => {
  //   if (!canvas) return;
  //   const dataURL = canvas.toDataURL({ format: "png" });
  //   const link = document.createElement("a");
  //   link.href = dataURL;
  //   link.download = "edited-image.png";
  //   link.click();
  // };

  const handleCanvasSizeChange = (e) => {
    const { name, value } = e.target;
    setCanvasSize((prev) => ({
      ...prev,
      [name]: value ? parseInt(value, 10) : 500,
    }));
  };

  const saveToHistory = () => {
    setHistory([...history, elements]);
    setRedoStack([]); // Clear redo stack on new change
  };

  const undo = () => {
    if (history.length === 0) return;
    const previousState = history[history.length - 1];
    setRedoStack([elements, ...redoStack]);
    setElements(previousState);
    setHistory(history.slice(0, -1));
  };

  const redo = () => {
    if (redoStack.length === 0) return;
    const nextState = redoStack[0];
    setHistory([...history, elements]);
    setElements(nextState);
    setRedoStack(redoStack.slice(1));
  };

  const [activeButton, setActiveButton] = useState("Hotels");
  const [allHotelsData, setAllHotelsData] = useState([]);
  const [allPackagesData, setAllPackagesData] = useState([]);
  const [allActivitiesData, setAllActivitiesData] = useState([]);
  const [allTransportData, setAllTransportData] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [singleActivityData, setSingleActivityData] = useState({});
  const [singlePackageData, setSinglePackageData] = useState({});

  const buttons = ["Packages", "Hotels", "Activities",];

  useEffect(() => {
    if (activeButton === "Hotels") {
      fetchAllHotels();
    } else if (activeButton === "Packages") {
      fetchAllPackages();
    } else if (activeButton === "Activities") {
      fetchAllActivities();
    } else if (activeButton === "Transport") {
      fetchAllTransport();
    }
  }, [activeButton]);

  const fetchAllHotels = async (data, filters) => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);
    setLoader(true);

    const formdata = new FormData();

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL
        }/api/v1/hotel-engine/check-availability`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      setAllHotelsData(result?.data?.properties);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Error fetching properties:", error);
    }
  };

  const fetchAllPackages = async (data, filters) => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    const formdata = new FormData();

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/holidays/fetch`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const result = await response.json();

      setAllPackagesData(result?.data);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const fetchAllActivities = async (data, filters) => {
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    const formdata = new FormData();

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/activities/fetch`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      const result = await response.json();
      setAllActivitiesData(result.data);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const fetchAllTransport = async (data) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/transport-holidays/fetch`, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "key": process.env.REACT_APP_BASE_API_KEY,
          "Cookie": process.env.REACT_APP_COOKIE
        },
        // body: JSON.stringify({
        //   hub: "Chandigarh",
        //   destination: ["Shimla", "Manali"],
        //   days: data?.noOfDays ? Number(data?.noOfDays) : 5
        // }),
        redirect: "follow"
      });

      const result = await response.json();
      setAllTransportData(result.data);
      setLoader(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (selectedActivity?.activityHandle) {
      fetchSingleActivityData()
    }
  }, [selectedActivity?.activityHandle]);

  useEffect(() => {
    if (selectedPackage?.packagehandle) {
      fetchSinglePackage(selectedPackage?.packagehandle)
    }
  }, [selectedPackage?.packagehandle]);

  const fetchSingleActivityData = () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    setLoader(true);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/activities/fetch/single/${selectedActivity?.activityHandle}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setSingleActivityData(result?.data);
        setLoader(false);
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const fetchSinglePackage = async (packageHandle) => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/holidays/fetch/single/${packageHandle}`,
        requestOptions
      );
      const data = await response.json();
      setSinglePackageData(data?.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const fetchAgentLogo = async (agentToken) => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${agentToken}`);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const formdata = new FormData();
    formdata.append("modelType", "agents");
    formdata.append("modelId", agent_selected_id?.id);
    formdata.append("upload_collection", "agent-logo");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/file/fetch`,
        requestOptions
      );
      const result = await response.json();
      if (result.success) {
        setAgentLogo(result?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (token && userType === "agent" && agentData) {
      fetchAgentLogo(token);
    }
  }, [token, agentData]);

  const fetchImageAsBase64 = async (imageUrl) => {
    const response = await fetch(imageUrl, {
      mode: 'cors',
      cache: 'no-store' // Force fresh request
    });

    if (!response.ok) throw new Error('Failed to fetch image');

    const blob = await response.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  // const updateBackgroundImage = async (imageUrl, defaultText = "Edit Me", templateIndex = 0) => {
  //   if (!canvas) return;

  //   canvas.getObjects()
  //     .filter(obj => obj.type !== 'background')
  //     .forEach(obj => canvas.remove(obj));

  //   const uploadedImage = new Image();
  //   uploadedImage.crossOrigin = "anonymous";
  //   uploadedImage.src = imageUrl;

  //   const backgroundBase64Image = await fetchImageAsBase64(uploadedImage.src);

  //   let agentBase64Image = null; // Declare outside to use later

  //   if (agentLogo) {
  //     try {
  //       agentBase64Image = await fetchImageAsBase64(agentLogo);
  //     } catch (error) {
  //       console.error("Failed to load agent logo:", error);
  //     }
  //   }

  //   fabric.Image.fromURL(backgroundBase64Image, (img) => {
  //     img.set({
  //       left: 0,
  //       top: 0,
  //       scaleX: canvas.width / img.width,
  //       scaleY: canvas.height / img.height,
  //     });

  //     canvas.setBackgroundImage(img, () => {
  //       canvas.renderAll();
  //       setBackgroundImage(img);
  //     });

  //     const text = new fabric.Textbox(defaultText, {
  //       left: 0,
  //       top: canvas.height - 40,
  //       width: canvas.width,
  //       fontSize: 24,
  //       fill: "#ffffff",
  //       fontWeight: "bold",
  //       textAlign: "center",
  //       backgroundColor: "rgba(0,0,0,0.7)",
  //       selectable: true,
  //     });
  //     canvas.add(text);

  //     if (agentBase64Image) {
  //       fabric.Image.fromURL(agentBase64Image, (logo) => {
  //         logo.set({
  //           left: (canvas.width - logo.width * 0.5) / 2, // Center horizontally
  //           top: 20, // Position near the top
  //           scaleX: 0.5,
  //           scaleY: 0.5,
  //           selectable: true,
  //         });
  //         canvas.add(logo);
  //       });
  //     }
  //   }, { crossOrigin: 'anonymous' });
  // };

  const downloadImage = async () => {
    if (!canvas) return;

    try {
      const dataURL = canvas.toDataURL({
        format: 'png',
        quality: 1,
      });

      const timestamp = new Date().toISOString().replace(/[:.-]/g, '');

      let baseName = "edited-image";
      if (activeButton === 'Packages' && selectedPackage) {
        baseName = `${selectedPackage.packagehandle}`;
      } else if (activeButton === 'Hotels' && selectedHotel) {
        baseName = `${selectedHotel.hotel_slug}`;
      } else if (activeButton === 'Activities' && selectedActivity) {
        baseName = `${selectedActivity.activityHandle}`;
      }

      const fileName = `${baseName}-${timestamp}.png`;

      const link = document.createElement('a');
      link.href = dataURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Download failed:', error);

      // Fallback: Convert to blob if possible
      if (canvas.lowerCanvasEl && canvas.lowerCanvasEl.toBlob) {
        canvas.lowerCanvasEl.toBlob((blob) => {
          const url = URL.createObjectURL(blob);

          const timestamp = new Date().toISOString().replace(/[:.-]/g, '');

          let baseName = "edited-image";
          if (activeButton === 'Packages' && selectedPackage) {
            baseName = `${selectedPackage.packagehandle}`;
          } else if (activeButton === 'Hotels' && selectedHotel) {
            baseName = `${selectedHotel.hotel_slug}`;
          } else if (activeButton === 'Activities' && selectedActivity) {
            baseName = `${selectedActivity.activityHandle}`;
          }

          const fileName = `${baseName}-${timestamp}.png`;


          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.click();
          setTimeout(() => URL.revokeObjectURL(url), 100);
        }, 'image/png', 1);
      } else {
        alert('Download failed! Please ensure:\n1. All images support CORS\n2. No external blocked images');
      }
    }
  };

  const displayedData = allPackagesData && allPackagesData.length > 0 && allPackagesData.slice(startIndex, endIndex);
  const displayedHotelsData = allHotelsData && allHotelsData.length > 0 && allHotelsData.slice(startIndex, endIndex);
  const displayedActivitiesData = allActivitiesData && allActivitiesData.length > 0 && allActivitiesData.slice(startIndex, endIndex);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [selectedTemplateButton, setSelectedTemplateButton] = useState("Packages");
  const [activeTemplate, setActiveTemplate] = useState(0); // Default to first template

  const templateButtonOptions = ["Hotels", "Packages", "Activities", "Transport"];

  const [isTemplateSelectOpen, setIsTemplateSelectOpen] = useState(false);

  // const getTemplates = (canvas) => [
  //   {
  //     name: "Bottom Text & Top Center Logo",
  //     textPosition: { left: canvas.width / 2, top: canvas.height - 70, originX: "center" },
  //     logoPosition: { left: canvas.width / 2, top: 20, originX: "center" },
  //     extraText: { left: canvas.width / 2, top: canvas.height - 100, originX: "center" }
  //   },
  //   {
  //     name: "Top Text & Bottom Right Logo",
  //     textPosition: { left: canvas.width / 2, top: 20, originX: "center" },
  //     logoPosition: { left: canvas.width - 130, top: canvas.height - 150 },
  //   },
  //   {
  //     name: "Center Text & Top Right Logo",
  //     textPosition: { left: canvas.width / 2, top: canvas.height / 2, originX: "center" },
  //     logoPosition: { left: canvas.width - 130, top: 20 },
  //   },
  //   {
  //     name: "Center Text & Top Left Logo",
  //     textPosition: { left: canvas.width / 2, top: canvas.height / 2, originX: "center" },
  //     logoPosition: { left: 20, top: 20 },
  //   },
  // ];

  // const getTemplates2 = (canvas) => [
  //   {
  //     name: "Center Text & Top Center Logo",
  //     textPosition: { left: canvas.width / 2, top: canvas.height - 70, originX: "center", textAlign: "center" },
  //     extraTextPosition: { left: canvas.width / 2, top: canvas.height - 70, originX: "center", textAlign: "center" },
  //     logoPosition: { left: canvas.width / 2, top: 20, originX: "center" },
  //   },
  //   {
  //     name: "Left Text & Top Center Logo",
  //     textPosition: { left: canvas.width / 2, top: canvas.height - 70, originX: "center", textAlign: "center", textAlign: "left" },
  //     extraTextPosition: { left: canvas.width / 2, top: canvas.height - 70, originX: "center", textAlign: "left" },
  //     logoPosition: { left: canvas.width / 2, top: 20, originX: "center" },
  //   },
  //   {
  //     name: "Right Text & Top Center Logo",
  //     textPosition: { left: canvas.width / 2, top: canvas.height - 70, originX: "center", textAlign: "center", textAlign: "right" },
  //     extraTextPosition: { left: canvas.width / 2, top: canvas.height - 70, originX: "center", textAlign: "right" },
  //     logoPosition: { left: canvas.width / 2, top: 20, originX: "center" },
  //   },
  // ];

  const [additionalData, setAdditionalData] = useState({});

  const getTemplates = (canvas) => [
    {
      name: "Center Text & Top Center Logo",
      textPosition: { left: canvas.width / 2, top: canvas.height - 70, originX: "center", textAlign: "center" },
      extraTextPosition: { left: canvas.width / 2, top: canvas.height - 50, originX: "center", textAlign: "center" }, // Below text
      logoPosition: { left: canvas.width / 2, top: 20, originX: "center" },
      image: topLogoCenterImage,
    },
    {
      name: "Left Text & Top Left Logo",
      textPosition: { left: canvas.width / 2, top: canvas.height - 70, originX: "center", textAlign: "left" },
      extraTextPosition: { left: canvas.width / 2, top: canvas.height - 50, originX: "center", textAlign: "left" }, // Below text
      logoPosition: { left: 0, top: 20, originX: "left" },
      image: topLogoLeftImage,
    },
    {
      name: "Right Text & Top Right Logo",
      textPosition: { left: canvas.width / 2, top: canvas.height - 70, originX: "center", textAlign: "right" },
      extraTextPosition: { left: canvas.width / 2, top: canvas.height - 50, originX: "center", textAlign: "right" }, // Below text
      logoPosition: { left: canvas.width, top: 20, originX: "right" },
      image: topLogoRightImage,
    },


    {
      name: "Center Text & Bottom Center Logo",
      textPosition: { left: canvas.width / 2, top: canvas.height - 70, originX: "center", textAlign: "center" },
      extraTextPosition: { left: canvas.width / 2, top: canvas.height - 50, originX: "center", textAlign: "center" }, // Below text
      logoPosition: { left: canvas.width / 2, top: canvas.height - 140, originX: "center" },
      image: bottomLogoCenterImage,
    },
    {
      name: "Left Text & Bottom Left Logo",
      textPosition: { left: canvas.width / 2, top: canvas.height - 70, originX: "center", textAlign: "left" },
      extraTextPosition: { left: canvas.width / 2, top: canvas.height - 50, originX: "center", textAlign: "left" }, // Below text
      logoPosition: { left: 0, top: canvas.height - 140, originX: "left" },
      image: bottomLogoLeftImage,
    },
    {
      name: "Right Text & Bottom Right Logo",
      textPosition: { left: canvas.width / 2, top: canvas.height - 70, originX: "center", textAlign: "right" },
      extraTextPosition: { left: canvas.width / 2, top: canvas.height - 50, originX: "center", textAlign: "right" }, // Below text
      logoPosition: { left: canvas.width, top: canvas.height - 140, originX: "right" },
      image: bottomLogoRightImage,
    },
  ];

  const handleTemplateChange = (index) => {
    setActiveTemplate(index);
    applyTemplate(index, "Edit Me", additionalData);  // Pass stored additionalData
  };

  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    if (canvas) {
      setTemplates(getTemplates(canvas));
    }
  }, [canvas]);

  const updatePackageImage = async (imageUrl, packageData) => {
    setShowDownloadButton(true);

    const newAdditionalData = {
      totalDays: packageData?.totalDays,
      totalNights: packageData?.totalNights,
      packageHub: packageData?.packageHub
    };

    setAdditionalData(newAdditionalData); 

    await updateBackgroundImage(imageUrl, packageData?.packageName, 0, newAdditionalData);
  };

  const updateActivityImage = async (imageUrl, activityData) => {
    setShowDownloadButton(true);

    const newAdditionalData = {
      activityRates: activityData?.activityRates[0],
      activityCity: activityData?.activityDestination
    };

    setAdditionalData(newAdditionalData);

    await updateBackgroundImage(imageUrl, activityData?.activityName, 0, newAdditionalData);
  };

  const updateHotelImage = async (imageUrl, hotelData) => {
    // await updateBackgroundImage(imageUrl, hotelData?.hotel_name, 2);
    setShowDownloadButton(true);

    const newAdditionalData = {
      startingPrice: hotelData?.starting_price,
      hotelCity: hotelData?.hotel_city
    };

    setAdditionalData(newAdditionalData);

    await updateBackgroundImage(imageUrl, hotelData?.hotel_name, 0, newAdditionalData);
  };

  const updateBackgroundImage = async (imageUrl, defaultText, templateIndex, additionalData = {}) => {
    if (!canvas) return;

    canvas.getObjects()
      .filter(obj => obj.type !== 'background')
      .forEach(obj => canvas.remove(obj));

    try {
      const backgroundBase64Image = await fetchImageAsBase64(imageUrl);

      fabric.Image.fromURL(backgroundBase64Image, (img) => {
        img.set({
          left: 0,
          top: 0,
          scaleX: canvas.width / img.width,
          scaleY: canvas.height / img.height,
        });

        canvas.setBackgroundImage(img, () => {
          canvas.renderAll();
          setBackgroundImage(img);
        });

        // Apply different templates for different categories
        applyTemplate(templateIndex, defaultText, additionalData);

      }, { crossOrigin: 'anonymous' });

    } catch (error) {
      console.error("Error updating background image:", error);
    }
  };

  const [storedAdditionalData, setStoredAdditionalData] = useState({});

  const applyTemplate = async (templateIndex, defaultText = "Edit Me", additionalData = {}, agentBase64Image = null) => {
    if (!canvas) return;

    const selectedTemplate = templates[templateIndex];
    if (!selectedTemplate) return;

    const finalAdditionalData = Object.keys(additionalData).length ? additionalData : storedAdditionalData;

    if (Object.keys(additionalData).length) {
      setStoredAdditionalData(additionalData);
    }

    // Get the existing text object if available
    const existingTextObject = canvas.getObjects().find(obj => obj.type === "textbox");
    const existingText = existingTextObject ? existingTextObject.text : defaultText;

    // Remove existing objects except the background
    canvas.getObjects()
      .filter(obj => obj.type !== 'background')
      .forEach(obj => canvas.remove(obj));

    // Add main title text
    const text = new fabric.Textbox(existingText, {
      left: selectedTemplate.textPosition.left,
      top: selectedTemplate.textPosition.top,
      width: canvas.width,
      fontSize: 16,
      fill: "#000000",
      fontWeight: "500",
      textAlign: selectedTemplate.textPosition.textAlign,
      fontFamily: "Inter",
      backgroundColor: "#FFFFFFE5",
      selectable: true,
      evented: true,
      lockMovementX: true,
      lockMovementY: true,
    });

    if (selectedTemplate.textPosition.originX) {
      text.set({ originX: selectedTemplate.textPosition.originX });
    }

    canvas.add(text);

    if (finalAdditionalData?.totalDays || finalAdditionalData?.totalNights) {
      const detailsText = new fabric.Textbox(
        `Duration: ${finalAdditionalData.totalDays}D/${finalAdditionalData.totalNights}N  Hub: ${finalAdditionalData.packageHub}`,
        {
          left: selectedTemplate.extraTextPosition.left,
          top: selectedTemplate.extraTextPosition.top,
          width: canvas.width,
          fontSize: 14,
          fill: "#ffffff",
          fontWeight: "500",
          textAlign: selectedTemplate.extraTextPosition.textAlign,
          fontFamily: "Inter",
          backgroundColor: "#5C77A0",
          selectable: false,
          evented: false,
          lockMovementX: true,
          lockMovementY: true,
          extraText: true,
        }
      );

      if (selectedTemplate.extraTextPosition.originX) {
        detailsText.set({ originX: selectedTemplate.extraTextPosition.originX });
      }

      canvas.add(detailsText);
    }

    if (finalAdditionalData?.startingPrice || finalAdditionalData?.hotelCity) {
      const detailsText = new fabric.Textbox(
        `₹ ${finalAdditionalData.startingPrice} Per Night  City: ${finalAdditionalData.hotelCity}`,
        {
          left: selectedTemplate.extraTextPosition.left,
          top: selectedTemplate.extraTextPosition.top,
          width: canvas.width,
          fontSize: 14,
          fill: "#ffffff",
          fontWeight: "500",
          textAlign: selectedTemplate.extraTextPosition.textAlign,
          fontFamily: "Inter",
          backgroundColor: "#5C77A0",
          selectable: true,
          evented: true,
          lockMovementX: true,
          lockMovementY: true,
          extraText: true,
        }
      );

      if (selectedTemplate.extraTextPosition.originX) {
        detailsText.set({ originX: selectedTemplate.extraTextPosition.originX });
      }

      canvas.add(detailsText);
    }

    if (finalAdditionalData?.activityRates || finalAdditionalData?.activityCity) {
      const detailsText = new fabric.Textbox(
        `₹ ${finalAdditionalData.activityRates?.amount} For ${finalAdditionalData.activityRates?.pax} Adult  City: ${finalAdditionalData.activityCity}`,
        {
          left: selectedTemplate.extraTextPosition.left,
          top: selectedTemplate.extraTextPosition.top,
          width: canvas.width,
          fontSize: 14,
          fill: "#ffffff",
          fontWeight: "500",
          textAlign: selectedTemplate.extraTextPosition.textAlign,
          fontFamily: "Inter",
          backgroundColor: "#5C77A0",
          selectable: true,
          evented: true,
          lockMovementX: true,
          lockMovementY: true,
          extraText: true,
        }
      );

      if (selectedTemplate.extraTextPosition.originX) {
        detailsText.set({ originX: selectedTemplate.extraTextPosition.originX });
      }

      canvas.add(detailsText);
    }

    // Add logo if available
    if (agentLogo) {
      try {
        agentBase64Image = await fetchImageAsBase64(agentLogo);
      } catch (error) {
        console.error("Failed to load agent logo:", error);
      }
    }

    // if (agentBase64Image) {
    //   fabric.Image.fromURL(agentBase64Image, (logo) => {
    //     logo.set({
    //       left: selectedTemplate.logoPosition.left,
    //       top: selectedTemplate.logoPosition.top,
    //       scaleX: 0.5,
    //       scaleY: 0.5,
    //       // selectable: true,

    //       selectable: false,
    //       evented: false,
    //       lockMovementX: true,
    //       lockMovementY: true,
    //     });

    //     if (selectedTemplate.logoPosition.originX) {
    //       logo.set({ originX: selectedTemplate.logoPosition.originX });
    //     }

    //     canvas.add(logo);
    //   });
    // }
    if (agentBase64Image) {
      fabric.Image.fromURL(agentBase64Image, (logo) => {
        const maxLogoWidth = 100;  // set max width
        const maxLogoHeight = 60;  // set max height
    
        const originalWidth = logo.width;
        const originalHeight = logo.height;
    
        const scaleX = maxLogoWidth / originalWidth;
        const scaleY = maxLogoHeight / originalHeight;
    
        // Maintain aspect ratio
        const scale = Math.min(scaleX, scaleY);
    
        logo.set({
          left: selectedTemplate.logoPosition.left,
          top: selectedTemplate.logoPosition.top,
          scaleX: scale,
          scaleY: scale,
          selectable: false,
          evented: false,
          lockMovementX: true,
          lockMovementY: true,
        });
    
        if (selectedTemplate.logoPosition.originX) {
          logo.set({ originX: selectedTemplate.logoPosition.originX });
        }
    
        canvas.add(logo);
        canvas.renderAll(); // Ensure it's refreshed
      });
    }
    
    canvas.renderAll();
  };

  const [step, setStep] = useState(1);

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  // const applyTemplate = async (templateIndex) => {
  //   if (!canvas) return;

  //   const selectedTemplate = templates[templateIndex];

  //   // Remove existing objects except the background
  //   canvas.getObjects()
  //     .filter(obj => obj.type !== 'background')
  //     .forEach(obj => canvas.remove(obj));

  //   // Add text
  //   const text = new fabric.Textbox("Edit Me", {
  //     left: selectedTemplate.textPosition.left,
  //     top: selectedTemplate.textPosition.top,
  //     fontSize: 24,
  //     fill: "#ffffff",
  //     fontWeight: "bold",
  //     textAlign: "center",
  //     backgroundColor: "rgba(0,0,0,0.7)",
  //     selectable: true,
  //   });
  //   canvas.add(text);

  //   // Add logo if available
  //   if (agentLogo) {
  //     const agentBase64Image = await fetchImageAsBase64(agentLogo);
  //     fabric.Image.fromURL(agentBase64Image, (logo) => {
  //       logo.set({
  //         left: selectedTemplate.logoPosition.left,
  //         top: selectedTemplate.logoPosition.top,
  //         scaleX: 0.5,
  //         scaleY: 0.5,
  //         selectable: true,
  //       });
  //       canvas.add(logo);
  //     });
  //   }

  //   canvas.renderAll();
  // };


  // console.log(allHotelsData, 'allHotelsData');
  // console.log(allPackagesData, 'allPackagesData');
  // console.log(allActivitiesData, 'allActivitiesData');
  // console.log(selectedPackage, 'selectedPackage');
  // console.log(singlePackageData, 'singlePackageData');

  return (
    <div className={styles.image_editor}>
      <div className={styles.image_editor_left}>

        {step === 1 && (
          <>
            <div className={styles.nextPrevButtonSec}>
              <button onClick={nextStep} className={styles.nextButton}>Next</button>
              <span style={{ display: 'flex', justifyContent: 'flex-end' }}><span style={{ color: '#009A50' }}>STEP {step}</span>/3</span>
            </div>

            <div className={styles.findImageSec}>
              <h4>Find Image</h4>
              <div className={`${styles.findImageSecFilterBtn}  mb-20`}>
                {buttons.map((button, index) => (
                  <button
                    key={index}
                    onClick={() => [setActiveButton(button), setCurrentPage(1)]}
                    className={activeButton === button ? styles.active : ""}
                  >
                    {button}
                  </button>
                ))}
              </div>
              <h4>Add {activeButton} Image:</h4>
              {loader ? (
                <div className="flex flex_gap_20 flex_wrap">
                  <Loader size="3em" color="#009A50" />
                </div>
              ) : (
                <>
                  {activeButton === 'Hotels' ? (
                    <>
                      <div className={`${styles.hotel_row} flex flex_gap_10 flex_wrap`}>
                        {displayedHotelsData &&
                          displayedHotelsData?.map((item, index) => (
                            <div className={`${styles.hotel_row_item} pointer`} key={index}
                              onClick={() => {
                                setSelectedHotel(item);
                                setOpenPopupSection(true);
                              }}
                            >
                              <img src={item?.hotel_image[0] ? item?.hotel_image[0] : imgNotFound} />
                              <p>{item?.hotel_name}</p>
                            </div>
                          ))}
                      </div>
                      <div className="flex justify_content_center">
                        {displayedHotelsData && displayedHotelsData.length > 0 && (
                          <div className="communication_pagination">
                            <CustomPagination
                              currentPage={currentPage}
                              itemsPerPage={itemsPerPage}
                              totalItems={allHotelsData?.length}
                              onPageChange={handlePageChange}
                            // clearSelection={clearSelection}
                            />
                          </div>
                        )}
                      </div>
                    </>
                  ) : activeButton === 'Packages' ? (
                    <>
                      <div className={`${styles.hotel_row} flex flex_gap_10 flex_wrap`}>
                        {displayedData &&
                          displayedData?.map((item, index) => (
                              <div className={`${styles.hotel_row_item} pointer`} key={index}
                                onClick={() => {
                                  setSelectedPackage(item);
                                  setOpenPopupSectionPackage(true);
                                }}>
                                <img src={item?.featuredImage ? item?.featuredImage : imgNotFound} />
                                <p>{item?.packageName}</p>
                              </div>
                          ))}
                      </div>
                      <div className="flex justify_content_center">
                        {displayedData && displayedData.length > 0 && (
                          <div className="communication_pagination">
                            <CustomPagination
                              currentPage={currentPage}
                              itemsPerPage={itemsPerPage}
                              totalItems={allPackagesData?.length}
                              onPageChange={handlePageChange}
                            // clearSelection={clearSelection}
                            />
                          </div>
                        )}
                      </div>
                    </>
                  ) : activeButton === 'Activities' ? (
                    <>
                      <div className={`${styles.hotel_row} flex flex_gap_10 flex_wrap`}>
                        {displayedActivitiesData &&
                          displayedActivitiesData.map((item, index) => (
                            <div className={`${styles.hotel_row_item} pointer`} key={index}
                              onClick={() => {
                                setSelectedActivity(item);
                                setOpenPopupSectionActivity(true);
                              }}
                            >
                              <img src={item?.featuredImage ? item?.featuredImage : imgNotFound} />
                              <p>{item?.activityName}</p>
                            </div>
                          ))}
                      </div>

                      <div className="flex justify_content_center">
                        {displayedActivitiesData && displayedActivitiesData.length > 0 && (
                          <div className="communication_pagination">
                            <CustomPagination
                              currentPage={currentPage}
                              itemsPerPage={itemsPerPage}
                              totalItems={allActivitiesData?.length}
                              onPageChange={handlePageChange}
                            // clearSelection={clearSelection}
                            />
                          </div>
                        )}
                      </div>
                    </>
                  ) : activeButton === 'Transport' ? (
                    <select className="p-1 border rounded w-16">
                      <option value=""> Select an Option</option>
                      {allTransportData &&
                        allTransportData.map((item, index) => (
                          <option key={index} value={item.transport}>{item.transport}</option>
                        ))}
                    </select>
                  ) : null}
                </>
              )}
            </div>
          </>
        )}

        {openPopupSection && (
          <div className="popup_backdrop">
            <div className={styles.popup_section}>
              <div className="flex justify_content_between mb-10">
                <h4>Hotel Images</h4>
                <button onClick={() => setOpenPopupSection(false)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <mask id="mask0_6838_7002" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6838_7002)">
                      <path d="M6.39994 18.6537L5.34619 17.5999L10.9462 11.9999L5.34619 6.39994L6.39994 5.34619L11.9999 10.9462L17.5999 5.34619L18.6537 6.39994L13.0537 11.9999L18.6537 17.5999L17.5999 18.6537L11.9999 13.0537L6.39994 18.6537Z" fill="#333333" />
                    </g>
                  </svg>
                </button>
              </div>

              <div className={styles.image_grid}>
                {selectedHotel?.hotel_image.map((img, index) => (
                  <img key={index} src={img} alt={`Hotel Image ${index + 1}`} onClick={(e) => {
                    setBackgroundUrl(img)
                    updateHotelImage(img, selectedHotel);
                    setOpenPopupSection(false)
                  }} />
                ))}
              </div>
            </div>
          </div>
        )}

        {openPopupSectionActivity && (
          <div className="popup_backdrop">
            <div className={styles.popup_section}>
              <div className="flex justify_content_between mb-10">
                <h4>Activity Images</h4>
                <button onClick={() => setOpenPopupSectionActivity(false)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <mask id="mask0_6838_7002" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6838_7002)">
                      <path d="M6.39994 18.6537L5.34619 17.5999L10.9462 11.9999L5.34619 6.39994L6.39994 5.34619L11.9999 10.9462L17.5999 5.34619L18.6537 6.39994L13.0537 11.9999L18.6537 17.5999L17.5999 18.6537L11.9999 13.0537L6.39994 18.6537Z" fill="#333333" />
                    </g>
                  </svg>
                </button>
              </div>

              <div className={styles.image_grid}>
                {singleActivityData.activityImages &&
                  singleActivityData.activityImages.length > 0 &&
                  singleActivityData.activityImages.map((img, index) => (
                    <img key={index} src={img} alt={`Activity Image ${index + 1}`} onClick={(e) => {
                      setBackgroundUrl(img)
                      updateActivityImage(img, singleActivityData);
                      setOpenPopupSectionActivity(false)
                    }} />
                  ))}
              </div>
            </div>
          </div>
        )}

        {openPopupSectionPackage && (
          <div className="popup_backdrop">
            <div className={styles.popup_section}>
              <div className="flex justify_content_between mb-10">
                <h4>Package Images</h4>
                <button onClick={() => setOpenPopupSectionPackage(false)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <mask id="mask0_6838_7002" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6838_7002)">
                      <path d="M6.39994 18.6537L5.34619 17.5999L10.9462 11.9999L5.34619 6.39994L6.39994 5.34619L11.9999 10.9462L17.5999 5.34619L18.6537 6.39994L13.0537 11.9999L18.6537 17.5999L17.5999 18.6537L11.9999 13.0537L6.39994 18.6537Z" fill="#333333" />
                    </g>
                  </svg>
                </button>
              </div>

              <div className={styles.image_grid}>
                {singlePackageData.packageImages &&
                  singlePackageData.packageImages.length > 0 &&
                  singlePackageData.packageImages.map((img, index) => (
                    <img key={index} src={img} alt={`Activity Image ${index + 1}`} onClick={(e) => {
                      setBackgroundUrl(img)
                      updatePackageImage(img, singlePackageData);
                      setOpenPopupSectionPackage(false)
                    }} />
                  ))}
              </div>
            </div>
          </div>
        )}

        {step === 2 && (
          <>
            <div className={styles.nextPrevButtonSec}>
              <button onClick={prevStep} className={styles.prevButton}>Previous</button>
              <button onClick={nextStep} className={styles.nextButton} >Next</button>
              <span style={{ display: 'flex', justifyContent: 'flex-end' }}><span style={{ color: '#009A50' }}>STEP {step}</span>/3</span>
            </div>

            <div className={styles.template_sec}>
              <div className="flex justify_content_between align_items_center">
                <h4>Select Template</h4>
                {/* 
            <div className={styles.dropdownTemplateButtonFilter}>
              <button onClick={() => setIsTemplateSelectOpen(!isTemplateSelectOpen)}>
                {selectedTemplateButton}{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                  style={{
                    transform: isTemplateSelectOpen ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  <mask
                    id="mask0_6855_8756"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="14"
                    height="15"
                  >
                    <rect
                      y="14.5"
                      width="14"
                      height="14"
                      transform="rotate(-90 0 14.5)"
                      fill="#D9D9D9"
                    />
                  </mask>
                  <g mask="url(#mask0_6855_8756)">
                    <path
                      d="M7.0008 9.14202L11.3949 4.74791C11.5108 4.63202 11.6472 4.57554 11.8043 4.57845C11.9614 4.58147 12.0979 4.64092 12.2138 4.75681C12.3296 4.87279 12.3876 5.00929 12.3876 5.16631C12.3876 5.32332 12.3296 5.45982 12.2138 5.57581L7.74791 10.0506C7.64242 10.156 7.52425 10.2342 7.39338 10.2851C7.26252 10.3359 7.13166 10.3613 7.0008 10.3613C6.86994 10.3613 6.73908 10.3359 6.60822 10.2851C6.47736 10.2342 6.35918 10.156 6.2537 10.0506L1.7788 5.57581C1.66291 5.45982 1.60648 5.32181 1.60949 5.16179C1.6125 5.00176 1.67195 4.8638 1.78784 4.74791C1.90373 4.63202 2.04023 4.57408 2.19734 4.57408C2.35436 4.57408 2.49081 4.63202 2.6067 4.74791L7.0008 9.14202Z"
                      fill="#333333"
                    />
                  </g>
                </svg>
              </button>

              {isTemplateSelectOpen && (
                <ul className={styles.dropdownButtonFilterChild}>
                  {templateButtonOptions?.map((option) => (
                    <li
                      key={option}
                      className=""
                      onClick={() => {
                        setSelectedTemplateButton(option);
                        setIsTemplateSelectOpen(false);
                      }}
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              )}
            </div> */}
              </div>

              <div className={styles.template_sec_row}>
                {templates.map((template, index) => (
                  <div
                    key={index}
                    className={`${styles.template_sec_row_item} ${activeTemplate === index ? styles.active : ""}`}
                    onClick={() => handleTemplateChange(index)}
                  >
                    <img src={template.image} alt={template.name} />
                    <p>{template.name}</p>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

        {step === 3 && (
          <>
            <div className={styles.nextPrevButtonSec}>
              <button onClick={prevStep} className={styles.prevButton}>Previous</button>
              {/* <button onClick={nextStep} className={styles.nextButton}>Next</button> */}
              <span style={{ display: 'flex', justifyContent: 'flex-end' }}><span style={{ color: '#009A50' }}>STEP {step}</span>/3</span>
            </div>
            <div className={styles.textEditorMain}>
              {/* {selectedText && ( */}
              <h4>Edit Text</h4>
              <div className={styles.textEdit}>
                <label>
                  Font Size:
                  <input
                    type="number"
                    value={textSize}
                    onChange={(e) => {
                      setTextSize(e.target.value);
                      updateTextSize(e.target.value);
                    }}
                    className="p-1 border rounded"
                  />
                </label>
                <label>
                  Text Color:
                  <input
                    type="color"
                    value={"red"}
                    onChange={(e) => {
                      setTextColor(e.target.value);
                      updateTextColor(e.target.value);
                    }}
                    className="p-1 border rounded"
                  />
                </label>
                <label>
                  Font Weight:
                  <select
                    value={textWeight}
                    onChange={(e) => {
                      setTextWeight(e.target.value);
                      updateTextWeight(e.target.value);
                    }}
                    className="p-1 border rounded"
                  >
                    <option value="normal">Normal</option>
                    <option value="bold">Bold</option>
                    <option value="lighter">Lighter</option>
                    <option value="bolder">Bolder</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="300">300</option>
                    <option value="400">400</option>
                    <option value="500">500</option>
                    <option value="600">600</option>
                    <option value="700">700</option>
                    <option value="800">800</option>
                    <option value="900">900</option>
                  </select>
                </label>
                <label>
                  Font Family:
                  <select
                    value={selectedFont}
                    onChange={(e) => updateFontFamily(e.target.value)}
                    className="p-1 border rounded"
                  >
                    {googleFonts.map((font) => (
                      <option key={font} value={font}>
                        {font}
                      </option>
                    ))}
                  </select>
                </label>
              </div>
              {/* )} */}
            </div>
          </>
        )}

        <div className={styles.controls}>
          {/* <div className={styles.controls}>
          <label>
            Canvas Width:{" "}
            <input
              type="number"
              name="width"
              value={canvasSize.width}
              onChange={handleCanvasSizeChange}
              className="p-1 border rounded"
            />
          </label>
          <label>
            Canvas Height:{" "}
            <input
              type="number"
              name="height"
              value={canvasSize.height}
              onChange={handleCanvasSizeChange}
              className="p-1 border rounded"
            />
          </label>
        </div> */}

          {/* <div className="flex space-x-2">
            <input
              type="text"
              placeholder="Enter background image URL"
              value={backgroundUrl}
              onChange={handleBackgroundUrlChange}
              className="p-2 border rounded w-80"
            />
            <input
              type="file"
              accept="image/*"
              onChange={handleBackgroundUpload}
              className="p-2 border rounded"
            />
            {backgroundImage && (
              <button
                onClick={removeBackgroundImage}
                className="p-2 bg-red-500 text-white rounded"
              >
                Remove Background
              </button>
            )}
          </div> */}

          {/* <div style={{ display: "flex", gap: "10px" }}>
            <button onClick={undo} disabled={history.length === 0}>
            Undo
          </button>
          <button onClick={redo} disabled={redoStack.length === 0}>
            Redo
          </button>
            <button
              onClick={addText}
              className="p-2 bg-blue-500 text-white rounded"
            >
              Add Text
            </button>
          </div> */}
        </div>
      </div>

      <div className={styles.image_editor_right}>
        <div className={styles.canvas_container}>
          <canvas ref={canvasRef} className="delete-btn" />
          {selectedImage && (
            <button
              onClick={deleteSelectedImage}
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                backgroundColor: "red",
                color: "white",
                padding: "8px",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "14px",
                transition: "background-color 0.3s ease-in-out",
              }}
              className="delete-btn"
            >
              Delete Image
            </button>
          )}

          {backgroundImage && (
            <button
              onClick={removeBackgroundImage}
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                backgroundColor: "red",
                color: "white",
                padding: "4px",
                border: "none",
                cursor: "pointer",
                fontSize: "12px",
                transition: "background-color 0.3s ease-in-out",
              }}
              className="delete-btn"
            >
              Remove Background Image
            </button>
          )}
        </div>


        {showDownloadButton && (
          <button
            onClick={downloadImage}
            className="p-2 bg-green-500 text-white"
            style={{ backgroundColor: '#009A50', padding: '6px 10px', width: '100%', marginTop: '20px' }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
              <mask id="mask0_6722_3510" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="17">
                <rect x="0.5" y="0.5" width="16" height="16" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_6722_3510)">
                <path d="M8.5 11.0257L5.65383 8.1795L6.3565 7.4565L8 9.1V3.5H9V9.1L10.6435 7.4565L11.3462 8.1795L8.5 11.0257ZM4.70517 13.5C4.36839 13.5 4.08333 13.3833 3.85 13.15C3.61667 12.9167 3.5 12.6316 3.5 12.2948V10.4872H4.5V12.2948C4.5 12.3462 4.52139 12.3932 4.56417 12.4358C4.60683 12.4786 4.65383 12.5 4.70517 12.5H12.2948C12.3462 12.5 12.3932 12.4786 12.4358 12.4358C12.4786 12.3932 12.5 12.3462 12.5 12.2948V10.4872H13.5V12.2948C13.5 12.6316 13.3833 12.9167 13.15 13.15C12.9167 13.3833 12.6316 13.5 12.2948 13.5H4.70517Z" fill="white" />
              </g>
            </svg>

            Download
          </button>
        )}
      </div>
    </div>
  );
};

export default ImageEditor;

// <div className={styles.logo_sec}>
// <h4>Add Logo:</h4>
// <div className={styles.uploadContainer}>
//   <label htmlFor="upload" className={styles.uploadLabel}>
//     <FaPlus className={styles.icon} />
//     <p>Upload</p>
//     <input
//       id="upload"
//       type="file"
//       accept="image/*"
//       onChange={handleImageUpload}
//       className={styles.uploadInput}
//     />
//   </label>
// </div>
// </div>
